import Icon from '@components/v2/ui/Icon/Icon';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { WifiOff } from 'lucide-react';
import type { ReactNode } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';

const BANNER_HEIGHT = 48;
const BANNER_GAP = 1.5;

const BannerToBrandUseOffline = () => {
  const { translate } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{
        height: BANNER_HEIGHT,
        gap: BANNER_GAP,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'accent.main',
        color: 'accent.contrastText',
      }}
    >
      <Icon icon={WifiOff} />

      <Typography component="p" variant="subtitle1" color="inherit">
        {translate(LangEnum.BANNER_TO_BRAND_USE_OFFLINE_TEXT, {
          b: (chunks: ReactNode) => <strong>{chunks}</strong>,
        })}
      </Typography>
    </Stack>
  );
};

export default BannerToBrandUseOffline;
